import React from "react";
import { Box, Container, Grid, Typography, Button, Paper } from "@mui/material";
import AlarmOnIcon from "@mui/icons-material/AlarmOn";
import EmailIcon from "@mui/icons-material/Email";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";

const benefits = [
  {
    icon: <EmailIcon sx={{ fontSize: 40, color: "#EE964B" }} />,
    title: "Confirmaciones Automáticas",
    description:
      "Envía correos de confirmación y datos de reserva de manera automática, sin intervención manual.",
    bgColor: "#565254",
  },
  {
    icon: <NotificationsActiveIcon sx={{ fontSize: 40, color: "#EE964B" }} />,
    title: "Recordatorios Programados",
    description:
      "Notifica a tus huéspedes sobre check-ins, pagos pendientes y eventos importantes.",
    bgColor: "#565254",
  },
  {
    icon: <SettingsApplicationsIcon sx={{ fontSize: 40, color: "#EE964B" }} />,
    title: "Integración de Procesos",
    description:
      "Coordina tareas administrativas como facturación, pagos y actualizaciones sin esfuerzo.",
    bgColor: "#565254",
  },
  {
    icon: <AlarmOnIcon sx={{ fontSize: 40, color: "#EE964B" }} />,
    title: "Gestión en Segundo Plano",
    description:
      "Automatiza tareas repetitivas para que tu hospedaje siga funcionando, incluso cuando descansás.",
    bgColor: "#565254",
  },
];

function HeroAutomation() {
  return (
    <Box
      sx={{
        scrollSnapAlign: "start",
        background: "linear-gradient(180deg, #d2c2f2, #903AF2 50%)",
        height: "100%",
        color: "white",
        py: 8,
        px: 3,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="center">
          {/* Información principal */}
          <Grid item xs={12} md={6}>
            <Typography
              variant="h3"
              fontWeight="bold"
              gutterBottom
              color={"#fff"}
              sx={{ fontFamily: "'Red Hat Display', sans-serif" }}
            >
              Automatización Inteligente
            </Typography>
            <Typography
              variant="body1"
              sx={{
                mb: 4,
                fontFamily: "'Merriweather Sans', sans-serif",
                color: "#fff",
              }}
            >
              Ahorrá tiempo con tareas automáticas que trabajan por vos. Desde
              correos de confirmación hasta mensajes de bienvenida o
              recordatorios de pago, con Ubika podés programar automatizaciones
              que mejoran la experiencia del huésped y reducen tu carga de
              trabajo.
            </Typography>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "#EE964B",
                color: "#ffffff",
                fontWeight: "bold",
                fontFamily: "'Red Hat Display', sans-serif",
                px: 4,
                py: 1.5,
                borderRadius: "12px",
                "&:hover": {
                  backgroundColor: "#d97e3e",
                },
              }}
            >
              Solicitar Demo
            </Button>
          </Grid>

          {/* Beneficios principales */}
          <Grid item xs={12} md={6}>
            <Grid container spacing={4}>
              {benefits.map((benefit, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <Paper
                    elevation={3}
                    sx={{
                      p: 3,
                      borderRadius: "12px",
                      backgroundColor: benefit.bgColor,
                      color: "#ffffff",
                      transition: "transform 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-5px)",
                      },
                    }}
                  >
                    {benefit.icon}
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      gutterBottom
                      sx={{ mt: 2 }}
                    >
                      {benefit.title}
                    </Typography>
                    <Typography variant="body2">
                      {benefit.description}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default HeroAutomation;
